import IGenerateUsernamesReducer from "../reducers/interfaces/iGenerateUsernamesReducer";

const getUsername = (store: any) => store.get("usernames").toJS() as IGenerateUsernamesReducer;

const generateUsernamesSelectors = {
    loading: (store: any) => getUsername(store).loading,
    usernames: (store: any) => getUsername(store).usernames
};

export default generateUsernamesSelectors;